// Colour palettes for the pencil colour card (style guide R18 "Colour Palettes"):
// each base colour with four tints (mixed toward white) and four shades
// (mixed toward black).

const toRgb = (hex: string) => {
	const n = parseInt(hex.slice(1), 16);
	return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};

const toHex = (rgb: number[]) => '#' + rgb.map(c => Math.round(Math.max(0, Math.min(255, c))).toString(16).padStart(2, '0')).join('').toUpperCase();

const mix = (hex: string, target: number, amount: number) => toHex(toRgb(hex).map(c => c + (target - c) * amount));

export type PaletteRow = { base: string; tints: string[]; shades: string[] };

const row = (base: string): PaletteRow => ({
	base,
	// lightest first, approaching the base colour
	tints: [0.8, 0.6, 0.4, 0.2].map(t => mix(base, 255, t)),
	// slightly darker first, approaching black
	shades: [0.2, 0.4, 0.6, 0.8].map(t => mix(base, 0, t)),
});

export const PALETTE_GROUPS: { label: string; rows: PaletteRow[] }[] = [
	{ label: 'Primary', rows: ['#FF0000', '#0047FF', '#FFFF00'].map(row) },
	{ label: 'Secondary', rows: ['#00E640', '#FF9900', '#9900FF'].map(row) },
	{
		label: 'Greys',
		rows: [{ base: '#000000', tints: ['#FFFFFF', '#D9D9D9', '#A6A6A6', '#737373'], shades: ['#404040', '#262626', '#1A1A1A', '#0D0D0D'] }],
	},
];
